import React from "react";
import { FlexibleLayout, LayoutFooter, LayoutHeader, Text, LayoutSidebarRight, LayoutMain} from "retro-react";
import { useNavigate } from "react-router-dom";
import './About.css';
import nick2 from '../../assets/nick2.png'
import bioString from '../../assets/bio.json'
import InterestTable from "./leftbox/TableOne";
import DetailsTable from "./leftbox/TableTwo";
import useIsMobile from '../../hooks/useIsMobile'
import { fetchAbout } from "../../api/aboutContent";
import { MobileButtons, Buttons } from "./rightbox/AboutButtons";
import { useApi } from "../../hooks/useApi";
import { AboutBio } from "./rightbox/AboutBio";
import { fetchMedia } from "../../api/media";
import { AboutImage } from "./AboutImage";
import he from 'he';
import TableOne from "./leftbox/TableOne";
import TableTwo from "./leftbox/TableTwo";
import { LoadingBox } from "../../components/LoadingBox";


const About = () => {
    const navigate = useNavigate();
    const isMobile = useIsMobile();
    const { output, loading, error } = useApi(fetchAbout);

    if (loading) {
        return (
            <div className="loading-wrapper">
              <LoadingBox/>
            </div>
          )
    }
    
    if (error) {
        return <p>Error loading data.</p>;
    }

    const aboutJSON = output[0]; //select first value

    const aboutTitle = he.decode(aboutJSON.title.rendered);
    const aboutImageID = aboutJSON.acf.about_image;
    const aboutBio = aboutJSON.acf.bio;
    const aboutCopyright = aboutJSON.acf.copyright;
    const farLeftButtonTitle=aboutJSON.acf.far_left_button_title;
    const farLeftMediaId=aboutJSON.acf.far_left_button_file;
    const leftButtonTitle = aboutJSON.acf.left_button_title;
    const leftButtonMediaId = aboutJSON.acf.left_button_file;
    const middleButtonTitle = aboutJSON.acf.middle_button_link.title;
    const middleButtonUrl = aboutJSON.acf.middle_button_link.url;
    const rightButtonTitle = aboutJSON.acf.right_button_link.title;
    const rightButtonUrl = aboutJSON.acf.right_button_link.url;

    console.log(aboutJSON.acf.far_left_button_title);
    console.log(aboutJSON.acf.far_left_button_file);

    const tableOneTitle = aboutJSON.acf.t1_title;
        const tableOneN1 = aboutJSON.acf.t1_name1;
        const tableOneV1 = aboutJSON.acf.t1_value1;
        const tableOneN2 = aboutJSON.acf.t1_name2;
        const tableOneV2 = aboutJSON.acf.t1_value2;
        const tableOneN3 = aboutJSON.acf.t1_name3;
        const tableOneV3 = aboutJSON.acf.t1_value3;
    
    const tableTwoTitle = aboutJSON.acf.t2_title;
        const tableTwoN1 = aboutJSON.acf.t2_name1;
        const tableTwoV1 = aboutJSON.acf.t2_value1;
        const tableTwoN2 = aboutJSON.acf.t2_name2;
        const tableTwoV2 = aboutJSON.acf.t2_value2;
        const tableTwoN3 = aboutJSON.acf.t2_name3;
        const tableTwoV3 = aboutJSON.acf.t2_value3;
        const tableTwoN4 = aboutJSON.acf.t2_name4;
        const tableTwoV4 = aboutJSON.acf.t2_value4;


    return (
        <div className="page-container">
            <FlexibleLayout
                className="about-box"
                sx={{
                    '& .flexible-layout-child-cell': {
                        backgroundColor: 'lightgray',
                        border: '2px solid black'
                    }
                }}
            >
                <LayoutHeader>
                    <h1 className="title-box" >
                        {aboutTitle}
                            {isMobile ?
                        <MobileButtons
                            pFarLeftButtonTitle={farLeftButtonTitle}
                            pFarLeftMediaID={farLeftMediaId}
                            pLeftButtonTitle={leftButtonTitle}
                            pMediaID={leftButtonMediaId}
                            pMiddleButtonTitle={middleButtonTitle}
                            pMiddleButtonUrl={middleButtonUrl}
                            pRightButtonTitle={rightButtonTitle}
                            pRightButtonUrl={rightButtonUrl}
                        /> 
                        : 
                        <Buttons 
                        pFarLeftButtonTitle={farLeftButtonTitle}
                        pFarLeftMediaID={farLeftMediaId}
                        pLeftButtonTitle={leftButtonTitle}
                        pMediaID={leftButtonMediaId}
                        pMiddleButtonTitle={middleButtonTitle}
                        pMiddleButtonUrl={middleButtonUrl}
                        pRightButtonTitle={rightButtonTitle}
                        pRightButtonUrl={rightButtonUrl}
                        />}
                    </h1>

               
                </LayoutHeader>

                <LayoutMain className="left-box">
                    <AboutImage aboutImageID={aboutImageID}/>  
                    <TableOne 
                        pTableOneTitle={tableOneTitle}
                        pTableOneN1={tableOneN1}
                        pTableOneV1={tableOneV1}
                        pTableOneN2={tableOneN2}
                        pTableOneV2={tableOneV2}
                        pTableOneN3={tableOneN3}
                        pTableOneV3={tableOneV3}
                    /> 
                    <TableTwo
                        pTableTwoTitle={tableTwoTitle}
                        pTableTwoN1={tableTwoN1}
                        pTableTwoV1={tableTwoV1}
                        pTableTwoN2={tableTwoN2}
                        pTableTwoV2={tableTwoV2}
                        pTableTwoN3={tableTwoN3}
                        pTableTwoV3={tableTwoV3}
                        pTableTwoN4={tableTwoN4}
                        pTableTwoV4={tableTwoV4}
                        
                    />

                </LayoutMain>
                <LayoutFooter>
                    <Text variant="paragraph">
                    {aboutCopyright}
                   </Text> 
                </LayoutFooter>
           
                <LayoutSidebarRight>
                    
                    <AboutBio pBio = {aboutBio}/>

                </LayoutSidebarRight>
            </FlexibleLayout>
        </div>
    );
}

export default About;
